import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { resetPasswordWithToken } from '../services/api';
import { TextField, Button, Box, Typography, Alert, LinearProgress } from '@mui/material';
import { styled } from '@mui/material/styles';

const PasswordStrengthBar = styled(LinearProgress)(({ theme, value }) => ({
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(2),
  '& .MuiLinearProgress-bar': {
    backgroundColor:
      value < 30 ? theme.palette.error.main :
      value < 70 ? theme.palette.warning.main :
      theme.palette.success.main,
  },
}));

const ResetPassword = () => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [passwordStrength, setPasswordStrength] = useState(0);
  const location = useLocation();
  const token = new URLSearchParams(location.search).get('token');

  const checkPasswordStrength = (password) => {
    let strength = 0;
    if (password.length > 6) strength += 20;
    if (password.match(/[a-z]+/)) strength += 20;
    if (password.match(/[A-Z]+/)) strength += 20;
    if (password.match(/[0-9]+/)) strength += 20;
    if (password.match(/[$@#&!]+/)) strength += 20;
    return strength;
  };

  const handlePasswordChange = (e) => {
    const password = e.target.value;
    setNewPassword(password);
    setPasswordStrength(checkPasswordStrength(password));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      setMessage('密码不匹配，请重新输入');
      return;
    }
    if (passwordStrength < 20) {
      setMessage('密码强度不够，请设置更强的密码');
      return;
    }
    try {
      const response = await resetPasswordWithToken(token, newPassword);
      setMessage(response.data.message);
    } catch (error) {
      setMessage('发生错误，请重试');
    }
  };

  return (
    <Box sx={{ maxWidth: 400, margin: 'auto', mt: 4 }}>
      <Typography variant="h4" gutterBottom>
        重置密码
      </Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          fullWidth
          type="password"
          value={newPassword}
          onChange={handlePasswordChange}
          label="新密码"
          variant="outlined"
          margin="normal"
          required
        />
        <PasswordStrengthBar variant="determinate" value={passwordStrength} />
        <TextField
          fullWidth
          type="password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          label="确认密码"
          variant="outlined"
          margin="normal"
          required
        />
        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          sx={{ mt: 3, mb: 2 }}
        >
          设置新密码
        </Button>
      </form>
      {message && <Alert severity={message.includes('错误') ? 'error' : 'success'}>{message}</Alert>}
    </Box>
  );
};

export default ResetPassword;